/**
 * @ Author: Kamil Michalak (k.michalak@kstudio.pl)
 * @ Create Time: 2019-06
 * @ Modified by: Kamil Michalak (k.michalak@kstudio.pl)
 * @ Modified time: 2019-10
 */

export const urlFixHttpProtocolMismatch = url => {
	// if via http:// try make this the same like a domain
	// MTVW-937: url === null would result in "null" string
	//url = String(url)
	if (!url) return null
	if (url.startsWith("http:")) {
		return url.substring(5)
	}
	return url
}
